<template>
  <div class="breadcrumb">
    <WellsBreadcrumb
      v-if="type === 'wells'"
      :links="links"
    />
  </div>
</template>

<script>
import WellsBreadcrumb from '@/components/general-ui/breadcrumbs/Wells.vue';
export default {
  name: 'Breadcrumb',
  components: {
    WellsBreadcrumb
  },
  props: {
    links : {
      type: Array,
      default(){
        return [];
      }
    }
  },
  data() {
    return {
      type: 'wells',
    };
  },
  computed: {}
};
</script>
